import { ReactElement } from "react";
import Create from "@shared/FormTemplates/Create";
import CreateForm from "./CreateForm";
import createItemAPI from "@services/Clients/WhaleShark/partner/createItem";
import validator from "@validators/Clients/WhaleShark/partner/Partner.validate";
import formMapper from "@mappers/Clients/WhaleShark/partner/PartnerItem.mapper";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
